import { PersonEntry } from "frontend/contentful/schema/semantics";

export const getEnterpriseIdHeadshotSrc = (entry: PersonEntry) => {
  const modifiedDate = entry.sys.updatedAt?.split("T")[0];
  return `https://www.hbs.edu/api/headshot/${entry.fields.hbsEnterpriseID}?${modifiedDate}`;
};
